import PropTypes from 'prop-types';
import Iconify from '../../Iconify';
// material
import { alpha, useTheme, styled } from '@mui/material';
import { Typography, Box } from '@mui/material';
//
import { MIconButton } from '../../@material-extend';
// ----------------------------------------------------------------------

const ICON_SIZE = {
  width: 20,
  height: 20
};

const RootStyle = styled(Box)(({ theme }) => ({
  zIndex: 9,
  display: 'flex',
  alignItems: 'center',
  position: 'absolute',
  bottom: theme.spacing(2),
  right: theme.spacing(2),
  color: theme.palette.common.white,
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.grey[900], 0.48)
}));

const ArrowStyle = styled(MIconButton)(({ theme }) => ({
  padding: 6,
  opacity: 0.48,
  color: theme.palette.common.white,
  '&:hover': { opacity: 1 }
}));

// ----------------------------------------------------------------------

CarouselControlsArrowsIndex.propTypes = {
  index: PropTypes.number,
  total: PropTypes.number,
  arrowLine: PropTypes.bool,
  onNext: PropTypes.func,
  onPrevious: PropTypes.func
};

export default function CarouselControlsArrowsIndex({ arrowLine, index, total, onNext, onPrevious, ...other }) {
  const theme = useTheme();
  const isRTL = theme.direction === 'rtl';

  return (
    <RootStyle {...other}>
      <ArrowStyle size="small" onClick={onPrevious}>
        {arrowLine ? (
          <Iconify icon={isRTL ? 'icon-park-outline:right-c' : 'icon-park-outline:left-c'} {...ICON_SIZE} />
        ) : (
          <Iconify icon={isRTL ? 'raphael:arrowright' : 'raphael:arrowleft'} {...ICON_SIZE} />
        )}
      </ArrowStyle>

      <Typography variant="subtitle2">
        {index + 1}/{total}
      </Typography>

      <ArrowStyle size="small" onClick={onNext}>
        {arrowLine ? (
          <Iconify icon={isRTL ? 'icon-park-outline:left-c' : 'icon-park-outline:right-c'} {...ICON_SIZE} />
        ) : (
          <Iconify icon={isRTL ? 'raphael:arrowleft' : 'raphael:arrowright'} {...ICON_SIZE} />
        )}
      </ArrowStyle>
    </RootStyle>
  );
}
